import { FootballStandingsElements } from './sportType';

export const footballStandingsDefaultDataElements = [
  FootballStandingsElements.MATCHES_PLAYED,
  FootballStandingsElements.MATCHES_WON,
  FootballStandingsElements.MATCH_DRAW,
  FootballStandingsElements.MATCH_LOSSES,
  FootballStandingsElements.GOAL_DIFFERENCE,
  FootballStandingsElements.POINTS,
  FootballStandingsElements.TEAM_FORM,
];

export const footballStandingsMobileDefaultDataElements = [
  FootballStandingsElements.MATCHES_PLAYED,
  FootballStandingsElements.GOAL_DIFFERENCE,
  FootballStandingsElements.POINTS,
];
